import React from 'react'
import logoimg from '../../assets/MK1.3.png';
import { useLocation } from 'react-router-dom';

function UsedCodes() {
    const location = useLocation();

    var {usedCodes} = location.state;

    console.log(usedCodes);

  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      {/* headers */}
      <div className='headers  '>
        <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
      </div>
      {
            usedCodes.length &&(
                <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 '>
                    <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                        <div className='text-base w-[250px] text-center'>اسم الطالب </div>
                        <div className='text-base w-[200px] text-center'>الكود </div>
                        <div className='text-base w-[300px] text-center'>التاريخ </div>
                    </div>
                    {
                    usedCodes.length && usedCodes?.map((item,key)=>{
                        const date = new Date(item.updatedAt);

                        // Format the date as needed, e.g., "November 3, 2024, 07:55 AM"
                        const readableDate = date.toLocaleString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                        });

                        return(
                            <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' key={item._id}> 
                                <div dir='rtl' className='text-base w-[100px] text-center'>{(key+1)} </div>   
                                <div dir='rtl' className='text-base w-[250px] text-center'>{item.studentname} </div>   
                                <div dir='rtl' className='text-base w-[200px] text-center'>{item.code} </div>   
                                <div dir='rtl' className='text-base w-[300px] text-center'>{readableDate} </div>   
                            </div>
                        )
                        })
                    }                    
                </div>
                )
            }
      
    </div>
  )
}

export default UsedCodes
